export const getDepositIsProcessing = (state): boolean =>
  state.apiDeposit.isProcessing;
